"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _tinymce = _interopRequireDefault(require("tinymce"));

var _FontSizeSelect = _interopRequireDefault(require("rich-text-lib/components/formatting/FontSizeSelect"));

var _usageTracking = require("../../constants/usageTracking");

var _usageTracking2 = require("../../utils/usageTracking");

var _getComputedStyle = require("../../utils/getComputedStyle");

var TinyMceFontSize =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TinyMceFontSize, _Component);

  function TinyMceFontSize(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TinyMceFontSize);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TinyMceFontSize).call(this, props));

    _this.handleNodeChange = function (event) {
      var editor = _this.props.editor;
      var computedStyle = (0, _getComputedStyle.maybeGetComputedStyle)(editor.getWin(), event.element);

      if (!computedStyle) {
        return;
      }

      var fontSize = computedStyle.fontSize;

      var matched = _this.props.fontSizes.find(function (_ref) {
        var value = _ref.value;
        return value === fontSize;
      });

      var value = matched ? matched.value : null;

      _this.setState({
        value: value
      });
    };

    _this.handleChangeFont = function (event) {
      var editor = _this.props.editor;
      var value = event.target.value;
      editor.execCommand('hsfontsize', false, {
        value: value
      });
      (0, _usageTracking2.trackInteraction)(editor, 'tinymceFormatting', _usageTracking.CHANGE_FONT_SIZE, {
        method: 'button',
        value: value
      });
    };

    _this.state = {
      value: null
    };
    _this.fontSizes = props.fontSizes;
    return _this;
  }

  (0, _createClass2.default)(TinyMceFontSize, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var editor = this.props.editor;
      editor.on('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var editor = this.props.editor;
      editor.off('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "render",
    value: function render() {
      var placeholder = this.props.placeholder;
      var value = this.state.value;
      return _react.default.createElement(_FontSizeSelect.default, {
        dropdownClassName: "mce-hubspot-control",
        use: "on-dark",
        onChange: this.handleChangeFont,
        placeholder: placeholder,
        fontSizes: this.fontSizes,
        value: value
      });
    }
  }]);
  return TinyMceFontSize;
}(_react.Component);

exports.default = TinyMceFontSize;
TinyMceFontSize.propTypes = {
  editor: _react.PropTypes.instanceOf(_tinymce.default.Editor),
  fontSizes: _react.PropTypes.array.isRequired,
  placeholder: _react.PropTypes.string
};
module.exports = exports.default;